import gql from "graphql-tag";

// ===============
// Queries
// ===============
export const GET_USER_SIGNIN_DETAILS = gql`
  query getUserAuthDetails($refreshToken: String!) {
    getUserAuthDetails(refreshToken: $refreshToken) {
      errorCode
      message
      authDetails
    }
  }
`;

export const CHECK_ORG_CODE_EXISTS = gql`
  query checkOrgCodeExists($orgCode: String!) {
    checkOrgCodeExists(orgCode: $orgCode) {
      errorCode
      message
      exists
    }
  }
`;
